export const camelize = (str: string) =>
  str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) => {
    if (+match === 0) return '';
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
  });

const filesAllowed = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/bmp',
  'image/tiff',
  'image/x-jp2', // jp2
  'image/x-panasonic-raw', // raw
  'audio/mpeg',
  'audio/wav',
  'video/mp4',
  'video/mpeg',
  'video/x-msvideo',
  'video/x-flv', // flv
  'video/x-ms-wmv', // wmv
  'video/x-dv', // dif
  'video/quicktime', // mov
  'text/plain',
  'text/csv',
  'message/rfc822', // eml
  'application/pdf',
  'application/json',
  'application/msword', // doc dot
  'application/rtf',
  'application/vnd.visio',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.ms-outlook', // msg
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-word.template.macroenabled.12', // dotm
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template', // dotx
  'application/vnd.ms-word.document.macroenabled.12', // docm
  'application/excel', // xla xlt
  'application/x-excel', // xla xlt
  'application/x-msexcel', // xla
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel.sheet.binary.macroenabled.12', // xlsb
  'application/vnd.ms-excel.sheet.macroenabled.12', // xlsm
  'application/vnd.ms-excel.template.macroenabled.12', // xltm
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template', // xltx
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.ms-works', // wps
];

export const isFileTypeAllowed = (MIMEType: string) =>
  filesAllowed.includes(MIMEType);

export const isBrowserIE = () => {
  const agent = navigator.userAgent;
  return agent.indexOf('MSIE ') > -1 || agent.indexOf('Trident/') > -1;
};

export const extractContent = (s: string, space?: boolean) => {
  if (isBrowserIE()) {
    return s.replace(/<\/?[^>]+>/gi, ' ').replace('&nbsp;', '');
  }

  const span = document.createElement('span');
  span.innerHTML = s;
  if (space) {
    const children = span.querySelectorAll('*');
    children.forEach((child, index) => {
      if (children[index].textContent) children[index].textContent += ' ';
      else (children[index] as HTMLElement).innerText += ' ';
    });
  }
  return [span.textContent || span.innerText].toString().replace(/ +/g, ' ');
};
